export default __webpack_public_path__ + "static/media/covid.e8ae4830.jpg";